import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}
function cfg() { return { headers: getAuthHeaders(), timeout: 20000 }; }

export async function fetchEventosWebhook() {
  const base = getBase();
  if (!base) return [];
  try { const r = await axios.get(base + '/webhooks/eventos', cfg()); return Array.isArray(r?.data) ? r.data : []; } catch (_) { return []; }
}
export async function fetchWebhooks() {
  const base = getBase();
  if (!base) return [];
  try { const r = await axios.get(base + '/webhooks', cfg()); return Array.isArray(r?.data) ? r.data : []; } catch (_) { return []; }
}
export async function criarWebhook(body) {
  const base = getBase(); if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/webhooks', body, cfg());
}
export async function atualizarWebhook(id, body) {
  const base = getBase(); if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/webhooks/' + id, body, cfg());
}
export async function removerWebhook(id) {
  const base = getBase(); if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/webhooks/' + id, cfg());
}
export async function testarWebhook(id) {
  const base = getBase(); if (!base) throw new Error('Backend não configurado');
  const r = await axios.post(base + '/webhooks/' + id + '/testar', {}, cfg());
  return r?.data ?? null;
}
export async function fetchEntregasWebhook(id) {
  const base = getBase(); if (!base) return [];
  try { const r = await axios.get(base + '/webhooks/' + id + '/entregas', cfg()); return Array.isArray(r?.data) ? r.data : []; } catch (_) { return []; }
}
